// PL
export const reservasSmallHc = {
  createAlerta: {
    title: "Utwórz nowe przypomnienie",
    infoHeading: "Informacje o przypomnieniu",
    selectPropertyLabel: "Wybierz obiekt, do którego chcesz przypisać przypomnienie",
    dayLabel: "Wybierz dzień tygodnia:",
    dayMonday: "Poniedziałek",
    dayTuesday: "Wtorek",
    dayWednesday: "Środa",
    dayThursday: "Czwartek",
    dayFriday: "Piątek",
    daySaturday: "Sobota",
    daySunday: "Niedziela",
    selectTimeLabel: "Wybierz godzinę",
    sendAtLabel: "Zostanie wysłane o:",
    minutesLabel: "Minuty: {minutes}",
    previewPre: "Powiadomienie zostanie wysłane gościom w",
    previewMid: "o",
    descriptionLabel: "Opis powiadomienia",
    descriptionPlaceholder: "Wpisz opis powiadomienia",
    messageTypeLabel: "Wybierz rodzaj wiadomości do wysłania.",
    messageTypeSimple: "Zwykła wiadomość",
    messageTypeLink: "Wiadomość z linkiem na końcu",
    messageTypeFile: "Wiadomość z załączonym plikiem na końcu",
    linkFieldLabel: "Podaj link do wysłania z przypomnieniem",
    fileFieldLabel: "Wgraj plik do wysłania z przypomnieniem",
    fileNameLabel: "Nazwa pliku",
    cancel: "Anuluj",
    save: "Zapisz przypomnienie",
    errorDayRequired: "Dzień jest wymagany",
    errorTimeRequired: "Godzina jest wymagana",
    errorSelectMinutes: "Wybierz minuty",
    errorDescriptionRequired: "Opis jest wymagany",
    errorAttachmentRequired: "Załącznik jest wymagany albo ustaw rodzaj wiadomości na zwykłą",
  },
  reservationData: {
    statusConfirmed: "Potwierdzone",
    statusRejected: "Odrzucone",
    statusTentative: "Zależnie od dostępności",
    statusWithinCheckin: "W godzinach check-inu",
    statusFree: "Bez opłaty",
    modalTitleApprove: "Zatwierdzić prośbę?",
    modalTitleApproveTime: "Zatwierdzić o innej godzinie?",
    modalTitlePrioritize: "Potraktować ten check-in priorytetowo?",
    modalTitleReject: "Odrzucić prośbę?",
    modalTitleDefault: "Potwierdzić?",
    modalTextApprove: "Za chwilę zatwierdzisz wcześniejszy check-in dla:",
    modalTextApproveTime: "Potwierdzisz check-in o wskazanej godzinie dla:",
    modalTextPrioritize: "Powiemy gościowi, że zrobicie wszystko, żeby było gotowe na tę godzinę, choć zależy to od wcześniejszego wymeldowania i sprzątania. Wyślemy do:",
    modalTextReject: "Za chwilę odrzucisz wcześniejszy check-in dla:",
    modalTextDefault: "Potwierdź dla:",
    modalCtaApprove: "Tak, zatwierdź",
    modalCtaApproveTime: "Potwierdź godzinę",
    modalCtaPrioritize: "Tak, poinformuj",
    modalCtaReject: "Tak, odrzuć",
    modalCtaDefault: "Potwierdź",
    kpiRoom: "Pokój",
    kpiLodging: "Obiekt",
    guestsCount: "gość | goście | gości",
    adultsCount: "dorosły | dorośli | dorosłych",
    childrenCount: "dziecko | dzieci | dzieci",
    infantsCount: "niemowlę | niemowlęta | niemowląt",
    roomsCountValue: "{count} pokoi",
    holderRole: "Osoba rezerwująca",
    noEmail: "Brak przypisanego e-maila",
    writeWhatsapp: "Napisz na WhatsApp",
    noPhoneTitle: "Bez numeru telefonu nie da się wysłać przez WhatsApp. Można go dodać w «Edytuj rezerwację».",
    noPhone: "Brak przypisanego telefonu",
    kpiCheckin: "Check-in",
    kpiCheckout: "Check-out",
    earlyRequested: "Prośba o wcześniejszy check-in",
    arrivalRequested: "Prośba o godzinę przyjazdu",
    arrivesAt: "Przyjazd o {time}",
    actionApprove: "Zatwierdź",
    actionOtherTime: "Inna godzina",
    actionPrioritize: "Priorytet",
    actionReject: "Odrzuć",
    awaitingPayment: "Oczekiwanie na płatność gościa",
    cannotUndo: "Tej operacji nie da się cofnąć.",
    checkinTimeLabel: "Godzina check-inu",
    earlyPrioritisedTitle: "Wcześniejszy check-in priorytetowy",
    earlyApprovedTitle: "Wcześniejszy check-in zatwierdzony",
    earlyRejectedTitle: "Wcześniejszy check-in odrzucony",
    earlyLineApproved: "Przyjedzie o {time}",
    earlyLineApprovedOther: "Przyjedzie o {time} · prosił o {original}",
    earlyLineRejected: "Prosił o {time} · zamelduje się o zwykłej godzinie",
    earlyLineRejectedStd: "Prosił o {time} · zamelduje się o zwykłej godzinie ({std})",
    earlyLinePrioritised: "Chce przyjechać o {time} · powiedzieliśmy, że zrobimy, co się da",
    extRequestedTitle: "Przedłużenie pobytu – prośba",
    extAwaitingTitle: "Przedłużenie pobytu czeka na płatność",
    extConfirmedTitle: "Przedłużenie pobytu potwierdzone",
    extNights: "Dodane noce: {nights} · nowy wyjazd {date}",
    extAtProperty: "{amount} do zapłaty na miejscu",
    extPendingHost: "czeka na Twoją zgodę",
    lateRequestedTitle: "Późny check-out – prośba",
    lateAwaitingTitle: "Późny check-out – czeka na płatność",
    lateConfirmedTitle: "Późny check-out potwierdzony",
    lateRejectedTitle: "Późny check-out odrzucony",
    lateLeavesAt: "Wyjeżdża o {time}",
    lateWantsToLeave: "Chce wyjechać o {time}",
    lateInsteadOf: "(zamiast o {std})",
    latePaid: "Zapłacono: {amount}",
    lateCourtesy: "Godzina gratis, bez opłat",
    lateFree: "Bez opłat",
    lateCash: "{amount} gotówką przy wyjeździe",
    lateUnpaid: "{amount}, jeszcze niezapłacone",
    lateLineRejected: "Prosił o wyjazd o {time} · wyjeżdża o zwykłej porze",
    lateLineRejectedStd: "Prosił o wyjazd o {time} · wyjeżdża o zwykłej porze ({std})",
    requestedTimeHint: "Gość prosił o {time}",
    toastApproved: "Wcześniejszy check-in zatwierdzony",
    toastApprovedTime: "Nowa godzina zameldowania zatwierdzona",
    toastPrioritised: "Wcześniejszy check-in priorytetowy",
    toastRejected: "Wcześniejszy check-in odrzucony",
    toastNotified: "Gość został już powiadomiony.",
    toastNotNotified: "Nie udało się powiadomić gościa: napisz do niego sam.",
    toastAlreadyDecided: "Ta prośba była już rozpatrzona: gość nie został ponownie powiadomiony.",
    toastError: "Nie udało się zapisać decyzji. Spróbuj ponownie.",
    toastAlreadyPaid: "Było już opłacone: nie pobrano opłaty ponownie.",
    toastRefundMaybeDue: "Gość zapłacił za wcześniejszy check-in, a teraz przyjeżdża o zwykłej godzinie: w razie potrzeby zwróć pieniądze.",
    actionReadyNow: "Może już wejść",
    actionNotPossible: "Nie będzie możliwe",
    toastPaymentLinkFailed: "Nie udało się utworzyć linku do płatności: pobierz opłatę w inny sposób.",
    arrivalApprovedTitle: "Godzina przyjazdu potwierdzona",
    arrivalRejectedTitle: "Godzina przyjazdu odrzucona",
    arrivalLineRejected: "Chciał przyjechać o {time}",
    modalTextApproveArrival: "Potwierdzisz godzinę przyjazdu dla:",
    modalTextRejectArrival: "Odrzucisz godzinę przyjazdu dla:",
    toastArrivalApproved: "Godzina przyjazdu potwierdzona",
    toastArrivalRejected: "Godzina przyjazdu odrzucona",
    cancel: "Anuluj",
  },
  minStayModal: {
    summaryNoData: "Brak danych w wybranym zakresie",
    summaryHintMixed: "W tym zakresie wykryto kilka różnych minimalnych pobytów. Pole ustawiono na 1 noc, aby można było określić nową wartość.",
    summaryHintSingle: "W polu wczytano obecny minimalny pobyt dla wybranego zakresu.",
    errorMinOne: "Minimalny pobyt musi wynosić co najmniej 1 noc.",
    opStartLabel: "Zmiana minimalnego pobytu…",
    successUpdated: "Minimalny pobyt został zaktualizowany",
    errorUpdate: "Błąd przy aktualizacji minimalnego pobytu",
    errorUnknown: "Nieznany błąd",
    title: "Minimalny pobyt",
    description: "Ustaw minimalny pobyt w nocach dla wybranego zakresu dat.",
    detectedLabel: "Wykryte minimalne pobyty",
    minStayLabel: "Minimalny pobyt (noce)",
    decreaseAria: "Zmniejsz minimalny pobyt",
    minNightsPlaceholder: "np. 2",
    increaseAria: "Zwiększ minimalny pobyt",
    hint: "Minimalna liczba nocy, jaką gość musi zarezerwować.",
    cancel: "Anuluj",
    save: "Zapisz",
  },
  modalCompleteReservation: {
    errorContactRequired: "Aby kontynuować, uzupełnij jedno z dwóch pól (telefon lub e-mail)",
    successMsg: "Dane rezerwacji zostały uzupełnione",
    successTitle: "Proces zakończony pomyślnie",
    title: "Uzupełnij rezerwację",
    bookingDateLabel: "Daty rezerwacji",
    checkin: "Check-in",
    checkout: "Check-out",
    phoneRequiredHint: "* Jedyne pole wymagane",
    emailHint: "*Jeśli podasz e-mail, gość nie będzie musiał go wpisywać",
    responsibleLabel: "Podaj imię i nazwisko osoby odpowiedzialnej",
    responsiblePlaceholder: "Osoba odpowiedzialna za rezerwację",
    scheduleLabel: "Zaplanuj datę wysyłki linku do check-inu.",
    scheduleAuto: "Wysyłka automatyczna",
    schedule24: "24 godziny przed check-inem",
    schedule48: "48 godzin przed check-inem",
    schedule72: "72 godziny przed check-inem",
    scheduleWeek: "Tydzień przed check-inem",
    cancel: "Anuluj",
    complete: "Uzupełnij rezerwację",
  },
  payData: {
    errorNoPaymentRecord: "Nie udało się zidentyfikować zapisu płatności.",
    partialLinkGenerated: "Link do płatności został wygenerowany.",
    errorGenerateLink: "Nie udało się wygenerować linku.",
    partialRegistered: "Płatność częściowa została zapisana.",
    errorSavePartial: "Nie udało się zapisać płatności częściowej.",
    whatsappPartialMsg: "Dzień dobry {name}, oto link do opłacenia pozostałej kwoty za rezerwację: {url}",
    errorInvoicingNotActive: "Faktury elektroniczne nie są dostępne w Twoim planie.",
    fieldBillingProfile: "Profil do faktur",
    fieldCountry: "Kraj",
    fieldLegalName: "Nazwa firmy",
    fieldTaxId: "NIF/CIF/NIT",
    fieldAddressStreet: "Adres",
    fieldAddressCity: "Miasto",
    fieldAddressRegion: "Region",
    fieldAddressZip: "Kod pocztowy",
    fieldEmail: "E-mail",
    fieldIsActive: "Aktywuj profil",
    errorBillingIncomplete: "Uzupełnij dane do faktur. Brakuje: {fields}",
    invoiceLinkCopied: "Link do fakturowania został skopiowany.",
    reservationHasInvoice: "Ta rezerwacja ma już fakturę.",
    errorLoadReceipt: "Nie udało się wczytać rachunku.",
    errorDownloadReceipt: "Nie udało się pobrać rachunku.",
    guestOutOfWindow: "Gość jest poza 24-godzinnym oknem WhatsApp.",
    errorSendReceipt: "Błąd przy wysyłaniu rachunku.",
    charge: "Opłata",
    lodging: "Nocleg",
    servicesExtras: "Usługi i dodatki",
    free: "Bezpłatnie",
    ivaIncluded: "(w tym VAT {rate}%)",
    includedInPrice: "(wliczone w cenę)",
    pendingCharge: "Do zapłaty",
    viewBreakdown: "Zobacz rozbicie ceny",
    viewReceipt: "Zobacz rachunek",
    receiptInfoPre: "Rachunek informacyjny. Fakturę elektroniczną wystawia się z zakładki",
    chargesTab: "Opłaty",
    receiptInfoNoInvoice: "Rachunek informacyjny jest dostępny. Aby wystawiać faktury elektroniczne, uzupełnij dane do faktur.",
    reservationNumber: "Rezerwacja #{code}",
    currentStatus: "Obecny status",
    willChangeTo: "Zmieni się na:",
    saving: "Zapisywanie…",
    breakdownTitle: "Rozbicie ceny",
    discounts: "Rabaty",
    taxesAndFees: "Podatki i opłaty",
    ivaIncludedInPrice: "VAT ({rate}%) wliczony w cenę: {amount}",
    includesTaxes: "Zawiera podatki wliczone w cenę: {amount}",
    total: "Suma",
    close: "Zamknij",
    loadingReceipt: "Wczytywanie rachunku…",
    stayReceipt: "Rachunek za pobyt · {date}",
    downloadPdf: "Pobierz PDF",
    sending: "Wysyłanie…",
    sent: "Wysłano!",
    outOfWindow: "Poza oknem 24 h",
    sendWhatsapp: "Wyślij przez WhatsApp",
    stayDetail: "Szczegóły pobytu",
    ivaIncludedShort: "w tym VAT {rate}%",
    discount: "Rabat",
    nightsCount: "noc | noce | nocy",
    additionalCharges: "Opłaty dodatkowe",
    ivaShort: "VAT {rate}%",
    charged: "Pobrano",
    pending: "Do zapłaty",
    receiptGeneratedBy: "Rachunek wygenerowany przez",
    done: "Gotowe",
    registerPartial: "Zapisz płatność częściową",
    reservationTotal: "Suma rezerwacji",
    amountReceived: "Kwota już otrzymana",
    paid: "Zapłacone",
    pendingBalance: "Pozostało do zapłaty",
    amountExceedsTotal: "Otrzymana kwota przekracza sumę. Użyj statusu",
    paidStatus: "Zapłacone",
    internalNote: "Notatka wewnętrzna",
    optional: "(opcjonalnie)",
    notePlaceholder: "np. Pierwsza wpłata otrzymana przelewem...",
    autoLinkNote: "Po zapisaniu link do płatności zostanie automatycznie zaktualizowany na",
    cancel: "Anuluj",
    savePartial: "Zapisz płatność częściową",
    roomsCount: "{count} pokój | {count} pokoje | {count} pokoi",
    groupNotePre: "Kwota za",
    groupNoteCombined: "rezerwację łączoną",
    groupNoteMid: "szczegóły według pokoi poniżej.",
  },
};
